import { useQueryClient } from '@tanstack/react-query'

const useSettings = () => {
  const queryClient = useQueryClient()

  const initializeSettings = (setting) => {
    if (setting) {
      queryClient.invalidateQueries({ queryKey: [setting] })
    }
  }

  return { initializeSettings };
}

export default useSettings;
